// @flow
import React from 'react'
import cn from 'classnames'

import type { DisplayableData } from '../displayableData'
import MultiLineContainer from './MultiLineContainer'
import Entry from './Entry'
import multiLineCellTypes from './multiLineCellTypes'

import styles from './MultiLineCell.scss'

const emptyCell = '—'

type Props = {
  className?: string,
  type?: $Values<typeof multiLineCellTypes>,
  showDuty?: boolean,
  borderLeft?: boolean,
  borderRight?: boolean,
  data: DisplayableData,
  restrictWidth?: number,
  paddingRight?: number,
}

const MultiLineCellTotal = ({
  className,
  type = multiLineCellTypes.COMMON,
  showDuty,
  borderLeft,
  borderRight,
  data,
  restrictWidth,
  paddingRight,
}: Props) => {
  const { totalCount, totalSum, hasDuty, dutySum, subsidiesSum, totalWithoutSubsidiesSum } = data

  const bottomCell = type === multiLineCellTypes.TOTAL

  return (
    <MultiLineContainer
      className={cn(styles.root, className)}
      bottomSpace={bottomCell}
      borderRight={borderRight}
      restrictWidth={restrictWidth}
      type={type}
    >
      <Entry borderLeft={borderLeft} paddingRight={paddingRight} dipper>
        {totalCount}
      </Entry>

      {bottomCell && (
        <Entry borderLeft={borderLeft} paddingRight={paddingRight}>
          {totalWithoutSubsidiesSum || emptyCell}
        </Entry>
      )}

      {bottomCell && (
        <Entry borderLeft={borderLeft} paddingRight={paddingRight}>
          {subsidiesSum || emptyCell}
        </Entry>
      )}

      {showDuty ? (
        <Entry borderLeft={borderLeft} duty={hasDuty} type={type} paddingRight={paddingRight}>
          {dutySum}
        </Entry>
      ) : null}

      <Entry borderLeft={borderLeft} type={type} paddingRight={paddingRight} summary>
        {totalSum}
      </Entry>
    </MultiLineContainer>
  )
}

export default MultiLineCellTotal
